import { useBackend } from "../../services";

export const useSearchDiscogsReleases = () => {
  const { get } = useBackend();
  return async (query: string) => {
    return await get(`discogs/search?query=${query}`);
  };
};
